export default __webpack_public_path__ + "static/privacy-0003f4876af829253495f13ea5f905bd.png";